import { Link } from 'react-router-dom';
import { Card } from '../../components/ui';
import './Home.css';

export default function TarjetaOpcionHome({ to, icono, titulo, descripcion }) {
  return (
    <Link className="home-card-link" to={to}>
      <Card hover>
        <div className="home-card-icon" aria-hidden="true">{icono}</div>
        <h3>{titulo}</h3>
        <p className="home-muted" style={{ margin: 0 }}>{descripcion}</p>
      </Card>
    </Link>
  );
}